import { pxToRem } from '../utils/font';

export const fonts = {
  sans: 'Circular Pro, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  serif: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
};

export const fontWeights = {
  bold: 700,
  medium: 500,
  regular: 400,
};

export const fontSizes = {
  xs: pxToRem(12),
  sm: pxToRem(14),
  base: pxToRem(16),
  lg: pxToRem(20),
  xl: pxToRem(24),
  '2xl': pxToRem(28),
  '3xl': pxToRem(32),
};

export const lineHeights = {
  xs: pxToRem(16),
  sm: pxToRem(20),
  base: pxToRem(24),
  lg: pxToRem(28),
  xl: pxToRem(32),
  '2xl': pxToRem(36),
  '3xl': pxToRem(40),
};
